// extracted by extract-css-chunks-webpack-plugin
module.exports = {"customLink":"WckXc","noCursor":"g-wRa"};